import { z } from 'zod';

import { idSchema, isoDateSchema } from './common.schema';

export const apiKeyScopeSchema = z.enum(['read_only', 'read_write', 'widget_only']);

export const apiKeySchema = z.object({
  id: idSchema,
  workspace_id: idSchema,
  name: z.string(),
  prefix: z.string(),
  scope: apiKeyScopeSchema,
  expires_at: isoDateSchema.nullable().optional(),
  last_used_at: isoDateSchema.nullable().optional(),
  rotated_at: isoDateSchema.nullable().optional(),
  revoked_at: isoDateSchema.nullable().optional(),
  is_active: z.boolean(),
  created_at: isoDateSchema,
  updated_at: isoDateSchema,
});
export type ApiKey = z.infer<typeof apiKeySchema>;

export const createApiKeySchema = z.object({
  name: z.string().min(1).max(200),
  scope: apiKeyScopeSchema.default('read_only'),
  expires_in: z.enum(['never', '90d', '365d']).default('365d'),
  constraints: z
    .object({
      ip_allowlist: z.array(z.string()).optional(),
      events: z.array(z.string()).optional(),
    })
    .optional(),
});

/** Ответ при создании — единственный раз показываем full key */
export const createApiKeyResponseSchema = apiKeySchema.extend({
  full_key: z.string(),
});
